import React from "react";
import {
  renderPortableText,
  portableTextToPlainText,
} from "../utils/sanityHelpers";

// Helper function to render Sanity rich text content (Portable Text)
// This is now a wrapper around the main utility
export const renderRichText = (richTextArray, className = "") => {
  return renderPortableText(richTextArray, className);
};

// Helper function to extract plain text from rich text (for SEO/previews)
export const getPlainTextFromRichText = (richTextArray) => {
  return portableTextToPlainText(richTextArray);
};

export default renderRichText;
